
/**
 * PE Support Widget — E-Mail Konfiguration
 * Einmal eintragen, fertig.
 * 
 * ANLEITUNG EMAILJS:
 * 1. https://www.emailjs.com/docs/sdk/installation/ aufrufen
 * 2. Kostenlosen Account erstellen (200 E-Mails/Monat gratis)
 * 3. "Add New Service" → Gmail, Outlook, oder eigene Domain wählen
 * 4. "Email Templates" → Neues Template erstellen mit:
 *    - Subject: "Ihr Verifizierungscode PE Service — {{otp_code}}"
 *    - Body: "Ihr Code: {{otp_code}} (gültig 10 Min) | Ticket: {{ticket_nr}} | Techniker: {{techniker}}"
 * 5. Keys unten eintragen
 */

// ============================================
// HIER EINTRAGEN (einmalig):
// ============================================
window.PE_EMAILJS_PUBLIC   = '';  // z.B. 'abc123def456'
window.PE_EMAILJS_SERVICE  = '';  // z.B. 'service_pe123'  
window.PE_EMAILJS_TEMPLATE = '';  // z.B. 'template_otp456'
// ============================================

// OPTIONAL: n8n OTP Webhook (wenn n8n läuft und E-Mail-Node konfiguriert)
window.PE_N8N_OTP_WEBHOOK = '';

// Shopify E-Mail läuft immer als Fallback (kein Key nötig)
// Wenn kein Key → OTP wird telefonisch durch Techniker mitgeteilt
